export class Outpost {
  constructor(
    public id: number,
    public name: string,
  ) {}
}
